<template>
  <div class="banner-full-width" :style="`background-image: url(${imageUrl})`">
    <div class="banner-full-width__content">
      <h2 class="title" v-html="title"></h2>
      <a class="form-button primary" :href="actionUrl" target="_blank">
        <span v-html="actionTitle"></span>
      </a>
    </div>
    <span class="banner-full-width__disclaimer">{{ disclaimer }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  imageUrl: string;
  disclaimer: string;
  actionTitle: string;
  actionUrl: string;
}>();
</script>
